export enum ModalType {
  SUCCESS,
  ERROR,
  WARNING,
  SECONDARY,
  INFO
}
